import { Stack, Typography, useTheme } from "@mui/material";
import { useMemo } from "react";
import CenteredWrapper from "@entrilia/shared/components/CenteredWrapper.tsx";
import DataGrid from "@entrilia/shared/components/grid/DataGrid.tsx";
import { getMergedSx } from "@entrilia/shared/hooks/useMergedSx.ts";
import { getBiDataGridStyles } from "../../../../../utilities/Utilities.tsx";
import { columns } from "./usedByReportsGridProvider.tsx";
import type { UsedByReport } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  reports: UsedByReport[];
  minRows: number;
  maxRows: number;
}

const gridSx = {
  ".MuiDataGrid-columnHeaders [role=row]": {
    bgcolor: "background.paper",
    ".MuiDataGrid-columnHeader": {
      bgcolor: "background.paper",
    },
  },
  ".MuiDataGrid-columnSeparator": {
    display: "none",
  },
};

const columnHeaderHeight = 28;
const rowHeight = 38;

const UsedByReportsGrid = ({ reports, minRows, maxRows }: Props) => {
  const theme = useTheme();

  const sx = useMemo(() => getMergedSx(theme, getBiDataGridStyles, gridSx), [theme]);

  const containerHeight = Math.max(minRows, Math.min(maxRows, reports.length)) * rowHeight + columnHeaderHeight + 2;

  return (
    <Stack sx={{ height: containerHeight, width: "100%" }}>
      <DataGrid
        rows={reports}
        columns={columns}
        sx={sx}
        columnHeaderHeight={columnHeaderHeight}
        rowHeight={rowHeight}
        slots={{
          noRowsOverlay: () => (
            <CenteredWrapper>
              <Typography color="textSecondary">{"No usages"}</Typography>
            </CenteredWrapper>
          ),
        }}
      />
    </Stack>
  );
};

UsedByReportsGrid.displayName = "UsedByReportsGrid";

export default UsedByReportsGrid;
